<template>
	<div>
		<sui-modal
			v-model="open"
			size="tiny"
			role="dialog"
			tabindex="-1"
			aria-labelledby="modalConfirm"
			aria-hidden="true"
		>
			<sui-modal-header role="document">
				<slot name="title">
					<span :class="$style.blackFont">
						{{ title }}
					</span>
				</slot>
				<i
					class="close icon"
					style="float: right; cursor: pointer;"
					@click="cancel(callbackCancel)"
				></i>
			</sui-modal-header>
			<sui-modal-content role="document">
				<div
					class="ui icon message"
					style="padding: 0; text-align: center; background: transparent !important;-webkit-box-shadow: none; box-shadow: none;"
				>
					<i class="warning sign icon" style="color: #9f2241;"></i>
					<div class="content">
						<div class="header boldFont">
							{{ message }}
						</div>
						<p v-if="advertencia" :class="$style.advertencia">{{ advertencia }}</p>
						<p v-if="description"  >{{ description }}</p>
					</div>
				</div>
			</sui-modal-content>
			<sui-modal-actions>
				<base-button
					:disabled="loading"
					class="boldFont"
					@click="cancel(callbackCancel)"
				>
					{{ titleCancel || 'Cancelar' }}
				</base-button>
				<base-button
					ref="buttonOk"
					class="boldFont"
					style-button="danger"
					:disabled="loading"
					:loading="loading"
					@click="ok(callbackOk)"
				>
					{{ titleOk || 'Aceptar' }}
				</base-button>
			</sui-modal-actions>
		</sui-modal>
	</div>
</template>

<script>
import events from '@utils/context-vue';

const Component = {
	name: 'Confirm',
	comments: {},
	data() {
		return {
			id: 'ConfirmModal',
			type: 'error',
			message: '',
			description: '',
			title: '',
			advertencia: '',
			titleOk: '',
			titleOther: '',
			titleCancel: '',
			callbackOk: null,
			callbackOther: null,
			callbackCancel: null,
			open: false,
			loading: false
		};
	},
	mounted() {
		events.$on('setData', this.show);
		events.$on('setLoading', this.setLoading);
	},
	methods: {
		setLoading(loading) {
			// console.log('Inner loading', loading);
			this.loading = loading;
		},
		getVariant() {
			switch (this.type) {
				case 'error':
					return 'danger';
				case 'warn':
					return 'warning';
				case 'info':
					return 'info';
				case 'success':
					return 'success';
			}
		},
		show(params) {
			this.open = true;
			this.type = params.type || 'error';
			this.id = params.id || this.id;

			this.message = params.message;
			this.description = params.description;
            this.advertencia = params.advertencia;
			this.title = params.title;
			this.titleOk = params.titleOk;
			this.titleCancel = params.titleCancel;
			this.titleOther = params.titleOther;
			this.titleCancel = params.titleCancel;
			this.callbackOk = params.callbackOk;
			this.callbackOther = params.callbackOther;
			this.callbackCancel = params.callbackCancel;

			setTimeout(() => {
				this.$root.$emit('bv::show::modal', this.id);
				this.$root.$emit('bv::hide::modal', 'upArchivo');
			}, 50);
		},
		ok(callback = () => {}) {
			if (typeof callback !== 'undefined') callback(this.closeModal);
			this.$root.$emit('bv::hide::modal', this.id);
		},
		closeModal() {
			this.open = false;
		},
		cancel(callback = () => {}) {
			if (typeof callback !== 'undefined') callback();
			this.open = false;
			this.$root.$emit('bv::hide::modal', this.id);
		},
		toggle() {
			this.open = false;
		}
	}
};

export default Component;
</script>

<style lang="scss" module>
@import '@design';

.blackFont {
	font-family: $montserrat-black !important;
}
.advertencia{
	color: #9f2241 !important; 
	font-size: 14px; 
	padding-top: 10px;
}
</style>
